// Shared AudioContext singleton to avoid multiple contexts and centralize lifecycle
let sharedAudioContext: AudioContext | null = null;

export function getSharedAudioContext(): AudioContext {
    if (!sharedAudioContext) {
        // Safari compatibility via webkitAudioContext if present
        const Ctor: any =
            (window as any).AudioContext || (window as any).webkitAudioContext;
        sharedAudioContext = new Ctor();
    }
    return sharedAudioContext!;
}

export async function suspendSharedAudioContext(): Promise<void> {
    if (sharedAudioContext && sharedAudioContext.state !== 'suspended') {
        try {
            await sharedAudioContext.suspend();
        } catch (error) {
            console.debug('AudioContext suspend failed (expected in some cases):', error);
        }
    }
}

export async function resumeSharedAudioContext(): Promise<void> {
    if (sharedAudioContext && sharedAudioContext.state !== 'running') {
        try {
            await sharedAudioContext.resume();
        } catch (error) {
            console.debug('AudioContext resume failed (expected in some cases):', error);
        }
    }
}

export async function closeSharedAudioContext(): Promise<void> {
    if (sharedAudioContext) {
        try {
            await sharedAudioContext.close();
        } catch (error) {
            console.debug('AudioContext close failed during cleanup:', error);
        }
        sharedAudioContext = null;
    }
}
